import React from 'react';
import { AutoBind } from './lib/prevalent';
import FillInfo from './FillInfo';
import HowItWorks01 from './HowItWorks01';
import HowItWorks02 from './HowItWorks02';
import { SetErrorLanguage } from './text/error-code';
import { text_eng } from './text/text_eng';
import { text_rus } from './text/text_rus';
import './css/style.css';
import logo from './img/logo.svg';

const LanguageText = ['ENG', 'RUS'];

export default class Page extends React.Component {
    constructor(props) {
        super(props);
        AutoBind(this);
        this.state = {
            page: 1,
            showLangList: false,
            language: 0, aitxt: text_eng
        };
    }

    ShowPage(page) {
        this.setState({ page: page });
        window.scroll(0, 400);
    }
    onSwowLangList() {
        this.setState(prevState => ({ showLangList: !prevState.showLangList }));
    }
    onChangeLang() {
        this.setState(prevState => {
            const language = 1 - prevState.language;
            SetErrorLanguage(language === 1 ? 'rus' : 'eng');
            const aitxt = language === 1 ? text_rus : text_eng;
            return { showLangList: false, language: language, aitxt: aitxt }
        });
    }

    render() {
        const state = this.state;
        const aitxt = state.aitxt;
        return (
            <div className="fridn">
                <div className="s1_background"></div>
                <header className="header">
                    <div className="container">
                        <a href="/usdt_exchange" className="header_logo header_left_side">
                            <img src={logo} alt="Fridn" />
                        </a>
                        <div className="header_right_side">
                            <div className="header_change_lang">
                                <span onClick={this.onSwowLangList}>{LanguageText[state.language]}</span>
                                <ul className={state.showLangList ? 'language_list active' : 'language_list'}>
                                    <li className="language_list_item" onClick={this.onChangeLang}>
                                        <span>{LanguageText[1 - state.language]}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </header>
                <main className="main">
                    <section className="section s1">
                        <div className="container exchange">
                            <h1 className="page_title">{aitxt[0]}</h1>
                        </div>
                    </section>
                    <section className="section s2">
                        <div className="container">

                            {state.page === 1 && <FillInfo ShowPage={this.ShowPage} aitxt={aitxt} />}
                            {/*(state.page === 2 || state.page === 3) && <p className="breadcrumbs"><a href="#">{aitxt[0]}</a><a href="#">{aitxt[1]}</a></p>*/}
                            {state.page === 2 && <HowItWorks01 aitxt={aitxt} />}
                            {state.page === 3 && <HowItWorks02 aitxt={aitxt} />}

                        </div>
                    </section>
                </main>
                <footer className="footer">
                    <div className="container">
                        <div className="footer_bottom">
                            <div className="first_side">
                                <img src={logo} className="footer_logo" alt="logo" />
                            </div>
                            <p className="second_side">{aitxt[2]}</p>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}
